// ── Color swatches : hover/click image swap ───────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.color-swatch-item').forEach(function (swatch) {
    var imageUrl = swatch.dataset.variantImage;
    swatch.addEventListener('mouseenter', function () {
      if (window.innerWidth > 768 && imageUrl) {
        var productCard = swatch.closest('.grid-product');
        var mainImage = productCard && productCard.querySelector('.grid-product__image');
        if (mainImage) mainImage.setAttribute('src', imageUrl);
      }
    });
    swatch.addEventListener('mouseleave', function () {
      if (window.innerWidth > 768) {
        var productCard = swatch.closest('.grid-product');
        var firstImage = productCard && productCard.querySelector('.grid-product__link img');
        if (firstImage && firstImage.dataset.src) firstImage.setAttribute('src', firstImage.dataset.src);
      }
    });
    swatch.addEventListener('click', function () {
      if (window.innerWidth <= 768 && imageUrl) {
        var productCard = swatch.closest('.grid-product');
        var mainImage = productCard && productCard.querySelector('.grid-product__image');
        if (mainImage) mainImage.setAttribute('src', imageUrl);
      }
    });
  });
});

// ── Color swatches : navigation scroll (flèches) ─────────────────────
function scrollColors(id, offset) {
  var container = document.getElementById('color-scroll-' + id);
  if (container) {
    container.scrollBy({ left: offset, behavior: 'smooth' });
    setTimeout(function () { updateNavArrows(id); }, 300);
  }
}

function updateNavArrows(id) {
  var container = document.getElementById('color-scroll-' + id);
  var prevArrow = document.querySelector('.color-swatches-nav--' + id + '.nav-prev');
  var nextArrow = document.querySelector('.color-swatches-nav--' + id + '.nav-next');
  if (!container) return;
  var scrollLeft = container.scrollLeft;
  var maxScrollLeft = container.scrollWidth - container.clientWidth;
  if (prevArrow) prevArrow.classList.toggle('inactive', scrollLeft <= 0);
  if (nextArrow) nextArrow.classList.toggle('inactive', scrollLeft >= maxScrollLeft - 1);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.color-swatches-wrapper').forEach(function (wrapper) {
    var id = wrapper.id.replace('color-scroll-', '');
    updateNavArrows(id);
    wrapper.addEventListener('scroll', function () { updateNavArrows(id); });
  });
});

// ── Active le slider uniquement si overflow ───────────────────────────
function updateSwatchesOverflowState() {
  document.querySelectorAll('.caroussel-couleur[data-swatches-carousel]').forEach(function (carousel) {
    var wrapper = carousel.querySelector('.color-swatches-wrapper');
    if (!wrapper) return;

    // Détection "réelle" : flèches seulement si une pastille est coupée
    // (évite les faux positifs scrollWidth/clientWidth à cause des sub-pixels)
    var swatches = wrapper.querySelectorAll('.color-swatch-item');
    if (!swatches || swatches.length === 0) {
      carousel.classList.remove('is-overflowing');
      return;
    }

    var wrapRect = wrapper.getBoundingClientRect();
    var firstRect = swatches[0].getBoundingClientRect();
    var lastRect = swatches[swatches.length - 1].getBoundingClientRect();

    // Tolérance 1px
    var leftClipped = (firstRect.left < wrapRect.left - 1) || (wrapper.scrollLeft > 1);
    var rightClipped = (lastRect.right > wrapRect.right + 1);
    var isOverflowing = leftClipped || rightClipped;

    carousel.classList.toggle('is-overflowing', isOverflowing);

    // Si ça tient, on reset l'état des flèches
    if (!isOverflowing) {
      var prev = carousel.querySelector('.color-swatches-nav.nav-prev');
      var next = carousel.querySelector('.color-swatches-nav.nav-next');
      if (prev) prev.classList.add('inactive');
      if (next) next.classList.add('inactive');
    } else {
      // sinon on recalcul (position scroll)
      var id = wrapper.id && wrapper.id.replace('color-scroll-', '');
      if (id) updateNavArrows(id);
    }
  });
}

window.addEventListener('resize', function () {
  updateSwatchesOverflowState();
});
document.addEventListener('DOMContentLoaded', function () {
  updateSwatchesOverflowState();
  // Re-check après layout/fonts/images (évite flèches affichées à tort)
  requestAnimationFrame(updateSwatchesOverflowState);
  setTimeout(updateSwatchesOverflowState, 150);
  setTimeout(updateSwatchesOverflowState, 500);
});
